export default "/images/c0ee2edd66a6bbf7e9d3a83a08edaa96.avif";